<div class="rounded-lg w-full max-w-md">
    <div class="font-medium text-gray-700">
       {{ label ??  'Threshold Slider' }}
    </div>
    <div class="relative overflow-hidden">
        <mat-slider
        class="width-overflow-lg"
        [min]="min"
        [max]="max"
        [step]="step"
        (input)="handleChange()"
      >
        <input
        matSliderStartThumb
        [attr.aria-label]="(label || 'Range') + ' minimum'"
        [value]="value.selectedStipendFrom"
        [(ngModel)]="value.selectedStipendFrom"
        (blur)="onTouched()"
      />
      <input
        matSliderEndThumb
        [attr.aria-label]="(label || 'Range') + ' maximum'"
        [value]="value.selectedStipendUpto"
        [(ngModel)]="value.selectedStipendUpto"
        (blur)="onTouched()"
      />
      </mat-slider>
      
      <div class="d-flex justify-content-between">
        <span>Min: {{ value.selectedStipendFrom }}</span>
        <span>Max: {{ value.selectedStipendUpto }}</span>
      </div>
    </div>
  </div>
  